module.exports = __webpack_public_path__ + "assets/58b6bac6fba830c148ee5a93898258a1.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/lines/line_1.mp3
 ** module id = 51
 ** module chunks = 0
 **/